import { MultiselectCommand } from '../../core/model/command';
import { RentalObjectCategory } from '../model/const/enums';

export const rentalObjectCommand = {
  export: 'export',
  showInvoices: 'showInvoices',
  linkDocument: 'linkDocument',
  showDocuments: 'showRentalObjectDocuments',
  showStairCaseList: 'showStairCaseList',
  advertise: 'advertise',
  feeChange: 'feeChange',
  copyRooms: 'copyRooms',
  setLettingFeatures: 'setLettingFeatures',
  sendToHomeQ: 'sendToHomeQ',
  printBrokerInformation: 'printBrokerInformation',
  editCompany: 'editCompany',
  changeCategory: 'changeRentalObjectCategory',
};

export class RentalObjectMultiselectCommand extends MultiselectCommand {
  constructor(id: string, items: any[], category: RentalObjectCategory, itemsSource: any[], contextId?: string) {
    super(id, items, itemsSource, contextId);

    this.category = category;
  }

  readonly category: RentalObjectCategory;
}
